export enum SchedulerPeriodicity {
	undefined = 0,
	hourly = 1,
	daily = 2,
	weekly = 3,
	monthly = 4,
	yearly = 5,
}

export enum SchedulerDays {
	undefined = 0,
	mon = 1,
	tue = 2,
	wed = 3,
	thu = 4,
	fri = 5,
	sat = 6,
	sun = 7,
}

export enum SchedulerExpiration {
	undefined = 0,
	never = 1,
	date = 2,
	occurences = 3,
}
